module.exports = __webpack_public_path__ + "img/case1.81e19b27.png";